import { Card, CardContent, Typography, Box, Button } from "@mui/material"
import { NavLink } from "react-router-dom"
import { UserPlus, DollarSign, Handshake, ArrowRight } from "lucide-react"

const textColor = "#0d2561";
const itextColor = "#707070";

export function ContactsUpdatesWidget() {
  const activities = [
    {
      id: 1,
      description: "You connected with Sarah Johnson.",
      icon: <UserPlus style={{ width: 14, height: 14, color: "#0A66C2", marginTop: 2 }} />,
    },
    {
      id: 2,
      description: "Michael Chen closed a deal on 123 Oak Ave.",
      icon: <DollarSign style={{ width: 14, height: 14, color: "#0A66C2", marginTop: 2 }} />,
    },
    {
      id: 3,
      description: "Emily Rodriguez started a new RFP for commercial space.",
      icon: <Handshake style={{ width: 14, height: 14, color: "#0A66C2", marginTop: 2 }} />,
    },
  ]

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        {/* Title */}
        <Typography
          variant="h6"
          sx={{ color: textColor, fontWeight: 600, fontSize: "18px" }}
        >
          Contacts Updates
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{ fontSize: "14px", color: "text.secondary", mb: 3, mt: 1 }}
        >
          Activities: New connections, real estate deals closed, and new deal activity.
        </Typography>

        {/* Activity items */}
        <Box display="flex" flexDirection="column" gap={2}>
          {activities.map((activity) => (
            <Box key={activity.id} display="flex" alignItems="flex-start" gap={1.5}>
              {activity.icon}
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", fontWeight: 400, color: "#212529", lineHeight: 1.3 }}
              >
                {activity.description}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* View All link */}
        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: textColor, textTransform: "none", fontSize: "0.875rem" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all opportunities
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
